"use client";

import UniversalImageSlider from "@/shared/components/ImageSlider/UniversalImageSlider";
import { Store } from "@/types/store";
import { Box, Stack, Text, VStack } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import { I18nLink } from "../i18n/I18nLink";

const StoreCard = ({ store }: { store: Store }) => {
  const t = useTranslations();

  return (
    <Stack
      flex={1}
      alignItems={"center"}
      direction={{ base: "column", md: "row" }}
      gap={{base: '0'}}
    >
      <Box
        w="100%"
        maxW={{ base: "100%", md: "50%" }}
        px={{ base: "0px" }}
      >
        <UniversalImageSlider
          aspectRatio={{base: "412/230", md: "610/324"}}
          overflow={"hidden"}
          height={'100%'}
          images={store.images}
        />
      </Box>

      <VStack
        w="100%"
        maxW={{ base: "100%", md: "50%" }}
        flex={1}
        gap="24px"
        align="start"
        pt={"10px"}
        pl={{ base: "0px", md: "40px", lg: "80px" }}
        py={{ base: "26px", md: "24px", lg: "94px" }}
        px={{ base: "16px", md: "40px" }}
      >
        <Text textStyle="bold24">{store.name}</Text>
        <Text textStyle="medium16">
          {store.address}
          <br />
          {store.workHours}
        </Text>
        <I18nLink href={store.mapLink ?? "#"}>
          <Text textStyle="medium16" textDecoration="underline">
            {t("view_on_map")}
          </Text>
        </I18nLink>
      </VStack>
    </Stack>
  );
};

export default StoreCard;
